import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=53a1c96c&"
import script from "./DropdownItem.vue?vue&type=script&lang=js&"
export * from "./DropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./DropdownItem.vue?vue&type=style&index=0&id=53a1c96c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports